import React from 'react';
import { PropTypes } from 'prop-types';
import { Cropper } from 'react-image-cropper';
import LinearProgress from '@material-ui/core/LinearProgress';

export const AVATAR_SELECTOR_REVEAL = 'avatarSelectorReveal';

export default class CropAvatar extends React.Component {
  static propTypes = {
    existsImage: PropTypes.any,
    file: PropTypes.any,
    colors: PropTypes.any,
    setCropperRef: PropTypes.func,
    ratio: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    originX: PropTypes.number,
    originY: PropTypes.number
  };

  cropperStyles = () => {
    const { colors } = this.props;

    return {
      container: {
        maxWidth: '450px',
        display: 'flex'
      },
      img: {
        maxWidth: '450px'
      },
      clone: {
        maxWidth: '450px'
      },
      source_img: {
        WebkitFilter: 'blur(3.5px)',
        filter: 'blur(3.5px)',
        maxWidth: '450px'
      },
      dotInner: {
        borderColor: colors.primary
      },
      dotInnerCenterVertical: {
        borderColor: colors.primary,
        backgroundColor: colors.primary
      },
      dotInnerCenterHorizontal: {
        borderColor: colors.primary,
        backgroundColor: colors.primary
      },
      move: {
        outline: `2px dashed ${colors.primary}`
      }
    };
  };

  render() {
    const { file, existsImage, setCropperRef, ratio, width, height, originX, originY } = this.props;

    return (
      <div className="crop-avatar">
        <div className="crop-wrapper">
          <Cropper
            styles={this.cropperStyles()}
            ratio={ratio ? ratio : 1 / 1}
            width={width ? width : 150}
            height={height ? height : 150}
            originX={originX ? originX : 150}
            originY={originY ? originY : 150}
            src={file}
            ref={ref => setCropperRef(ref)}
          />
        </div>
        {existsImage ? <LinearProgress variant={'indeterminate'} /> : null}
      </div>
    );
  }
}
